export default function Logo() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0777 0.445607C17.4237 0.151811 16.7158 0 16 0C15.2842 0 14.5763 0.151811 13.9223 0.445607L3.03492 5.33615C1.18929 6.16513 0 8.01385 0 10.0538V21.9462C0 23.9862 1.18929 25.8349 3.03486 26.6639L13.9223 31.5544C14.5763 31.8482 15.2842 32 16 32C16.7158 32 17.4237 31.8482 18.0777 31.5544L28.9651 26.6639C30.8107 25.8349 32 23.9862 32 21.9462V10.0538C32 8.01385 30.8107 6.16513 28.9651 5.33615L18.0777 0.445607Z"
        fill="#202020"
      />
      <path
        opacity="0.5"
        d="M3.64951 6.70447L3.64955 6.70445L14.5369 1.8139C14.998 1.60678 15.4964 1.5 16 1.5C16.5036 1.5 17.002 1.60678 17.4631 1.8139L28.3505 6.70445L28.3505 6.70446C29.6515 7.28883 30.5 8.59812 30.5 10.0538V21.9462C30.5 23.4019 29.6516 24.7112 28.3505 25.2956L28.9651 26.6639L28.3505 25.2956L17.4631 30.1861C17.002 30.3932 16.5036 30.5 16 30.5C15.4964 30.5 14.998 30.3932 14.5369 30.1861L3.6495 25.2956C2.34845 24.7112 1.5 23.4019 1.5 21.9462V10.0538C1.5 8.59814 2.34844 7.28885 3.64951 6.70447Z"
        stroke="#5AB57A"
        strokeWidth="3"
      />
      <path
        d="M3.34221 6.02031L3.34224 6.0203L14.2296 1.12975C14.7872 0.879294 15.3903 0.75 16 0.75C16.6097 0.75 17.2128 0.879294 17.7704 1.12975L28.6578 6.0203L28.6578 6.02031C30.2311 6.72698 31.25 8.30599 31.25 10.0538V21.9462C31.25 23.694 30.2311 25.273 28.6578 25.9798L17.7704 30.8702C17.2129 31.1207 16.6097 31.25 16 31.25C15.3903 31.25 14.7871 31.1207 14.2296 30.8702L3.34218 25.9798C1.76887 25.273 0.75 23.694 0.75 21.9462V10.0538C0.75 8.30599 1.76887 6.72699 3.34221 6.02031Z"
        stroke="#5AB57A"
        strokeWidth="1.5"
      />
      <path
        d="M15.3104 14.7028H16.6897L16.6897 12.9286C16.6897 12.9286 16.6897 12.2949 16 12.2949C15.3103 12.2949 15.3103 12.9286 15.3103 12.9286L15.3104 14.7028Z"
        fill="#299679"
      />
      <path
        d="M15.972 12.8019C15.797 12.8019 15.6552 12.9437 15.6552 13.1187V13.1187C15.6552 13.2937 15.797 13.4355 15.972 13.4355H16.028C16.203 13.4355 16.3448 13.2937 16.3448 13.1187V13.1187C16.3448 12.9437 16.203 12.8019 16.028 12.8019H15.972Z"
        fill="#93D375"
      />
      <path
        d="M16 21.2927C16 21.2927 16.6897 19.265 16.6897 18.2512C16.6897 17.2374 16.6897 13.5622 16.6897 13.5622L16 14.1959L15.3103 13.5622C15.3103 13.5622 15.3103 17.2374 15.3103 18.2512C15.3103 19.265 16 21.2927 16 21.2927Z"
        fill="#04756F"
      />
      <path
        d="M16 21.2927L16.3448 15.1463C16.3448 15.1463 16.3448 14.8295 16 14.8295C15.6551 14.8295 15.6552 15.1463 15.6552 15.1463L16 21.2927Z"
        fill="#5AB57A"
      />
      <path
        d="M15.3104 16.2235L14.2759 14.0058L13.2414 11.788L9.44828 9L6 9.8871L7.03449 13.689L9.44828 15.4632L7.58622 18.7581L9.44828 22.56C9.44828 22.56 12.6897 23.1936 13.2414 22.9402C13.7931 22.6867 14.6207 21.2927 14.6207 21.2927L15.3104 17.7443"
        fill="#148575"
      />
      <path d="M11.3103 20.0254L14.6207 21.2927L15.3104 17.7443V16.8572L11.3103 20.0254Z" fill="#299679" />
      <path
        d="M9.44827 22.56C9.44827 22.56 12.6897 23.1936 13.2414 22.9402C13.7931 22.6867 14.6207 21.2927 14.6207 21.2927L11.3103 20.0254L9.44827 22.56Z"
        fill="#40A67B"
      />
      <path d="M9.44827 22.56L11.3103 20.0254L7.5862 18.7581L9.44827 22.56Z" fill="#D5EE6F" />
      <path d="M9.44826 15.4632L7.5862 18.7581L11.3103 20.0254L9.44826 15.4632Z" fill="#75C578" />
      <path d="M9.44827 15.4632L14.3103 17.6492L15.3103 16.8572L9.44827 15.4632Z" fill="#93D375" />
      <path d="M6 9.8871L9.44828 12.6751L15.3104 16.8572V16.2235L13.2414 11.788L9.44828 9L6 9.8871Z" fill="#299679" />
      <path d="M6 9.8871L9.44828 13.182V9L6 9.8871Z" fill="#40A67B" />
      <path d="M9.44827 9V12.6751L13.2414 11.788L9.44827 9Z" fill="#5AB57A" />
      <path d="M9.44826 12.6751L7.03447 13.689L9.44826 15.4632V12.6751Z" fill="#75C578" />
      <path d="M9.44828 12.6751L6 9.8871L7.03449 13.689L9.44828 12.6751Z" fill="#B3E172" />
      <path d="M9.44827 12.6751V15.4632L11.3103 15.9067L15.3103 16.8572L9.44827 12.6751Z" fill="#5AB57A" />
      <path
        d="M16.6896 16.2235L17.7241 14.0058L18.7586 11.788L22.5517 9L26 9.8871L24.9655 13.689L22.5517 15.4632L24.4138 18.7581L22.5517 22.56C22.5517 22.56 19.3103 23.1936 18.7586 22.9402C18.2069 22.6867 17.3793 21.2927 17.3793 21.2927L16.6896 17.7443"
        fill="#148575"
      />
      <path d="M20.6896 20.0254L17.3793 21.2927L16.6896 17.7443V16.8572L20.6896 20.0254Z" fill="#299679" />
      <path
        d="M22.5517 22.56C22.5517 22.56 19.3103 23.1936 18.7586 22.9402C18.2069 22.6867 17.3793 21.2927 17.3793 21.2927L20.6896 20.0254L22.5517 22.56Z"
        fill="#40A67B"
      />
      <path d="M22.5517 22.56L20.6896 20.0254L24.4138 18.7581L22.5517 22.56Z" fill="#D5EE6F" />
      <path d="M22.5517 15.4632L24.4138 18.7581L20.6896 20.0254L22.5517 15.4632Z" fill="#75C578" />
      <path d="M22.5517 15.4632L17.6896 17.6492L16.6896 16.8572L22.5517 15.4632Z" fill="#93D375" />
      <path d="M26 9.8871L22.5517 12.6751L16.6896 16.8572V16.2235L18.7586 11.788L22.5517 9L26 9.8871Z" fill="#299679" />
      <path d="M26 9.8871L22.5517 13.182V9L26 9.8871Z" fill="#40A67B" />
      <path d="M22.5517 9V12.6751L18.7586 11.788L22.5517 9Z" fill="#5AB57A" />
      <path d="M22.5517 12.6751L24.9655 13.689L22.5517 15.4632V12.6751Z" fill="#75C578" />
      <path d="M22.5517 12.6751L26 9.8871L24.9655 13.689L22.5517 12.6751Z" fill="#B3E172" />
      <path d="M22.5517 12.6751V15.4632L20.6896 15.9067L16.6896 16.8572L22.5517 12.6751Z" fill="#5AB57A" />
    </svg>
  );
}
